import { createSlice } from '@reduxjs/toolkit'
const initialState = {
	sidebarCollapsed: false,
}
export const ui = createSlice({
	name: 'ui',
	initialState,
	reducers: {
		toggleSidebar(state, { payload }) {
			window.localStorage.setItem('sidebar-collapsed', JSON.stringify(payload))
			state.sidebarCollapsed = payload
		},
	},
})
export const { toggleSidebar } = ui.actions
export default ui.reducer
